module.exports = __webpack_public_path__ + "static/media/hero-tesla.bc2b1e4d.webp";